/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ExpressOrderSubmitStateAction Input Action
 */
export class ExpressOrderSubmitStateActionInput implements Msdyn365.IActionInput {
    // ExpressOrderSubmitState: Construct the input needed to run the action
    constructor() {}

    // ExpressOrderSubmitState: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ExpressOrderSubmitState`;
    public getCacheObjectType = () => 'ExpressOrderSubmitState';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// ExpressOrderSubmitState: Create a data model here or import one to capture the response of the action
export interface IExpressOrderSubmitStateActionData {
    expressSubmit: boolean;
    slotTime: string;
    slotDate: string;
    selectedService: string;
}

/**
 * ExpressOrderSubmitState - create new input for create action
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ExpressOrderSubmitStateActionInput();
};

/**
 * ExpressOrderSubmitState - create action
 */
async function action(input: ExpressOrderSubmitStateActionInput, ctx: Msdyn365.IActionContext): Promise<IExpressOrderSubmitStateActionData> {

    return { expressSubmit: true , slotTime: '', slotDate: '', selectedService: ''};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IExpressOrderSubmitStateActionData>>action,
    // ExpressOrderSubmitState: Give your data action a unique id
    id: 'ExpressOrderSubmitStateAction',
    input: createInput
    // ExpressOrderSubmitState: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
